<template>
    <b-container v-if="loaded">
        <b-row>
            <b-col>
                <h1>
                    Create a New Client
                </h1>

                <b-form @submit.prevent="onSubmit">
                    <b-form-group>
                        <label>
                            Name
                        </label>

                        <b-form-input
                            type="text"
                            v-model="form.name"
                            required>    
                        </b-form-input>

                        <label>
                            User
                        </label>

                        <b-form-select
                                v-model="form.user_id"
                                :options="user_options"
                                class="mb-2">

                            <template slot="first">
                                <option :value="null" disabled>None</option>
                            </template>

                        </b-form-select>
                    </b-form-group>

                    <hr>

                    <b-form-group class="mt-0">
                        <b-row>
                            <b-col md-6>
                                <label>
                                    Logo
                                </label>

<!--                                <image-picker -->
<!--                                    :height="image_dimensions.height" -->
<!--                                    :width="image_dimensions.width" -->
<!--                                    @image-picked="(base64) => { form.logo_base64 = base64; }">-->
<!--                                </image-picker>-->
                                <simple-image-picker
                                    :src="form.logo"
                                    :width="200"
                                    :bg_color="form.header_color"
                                    @image-picked="(base64) => { form.logo_base64 = base64; }">
                                </simple-image-picker>
                            </b-col>

                            <b-col md-6>
                                <label>
                                    Colour Scheme
                                </label>

                                <colour-picker class="" 
                                    :colour="form.header_color"
                                    name="Header bar colour"
                                    @colour-picked="(new_color) => { form.header_color = new_color; }">
                                </colour-picker>

                                <colour-picker class="mt-3" 
                                    :colour="form.footer_color"
                                    name="Footer bar colour"
                                    @colour-picked="(new_color) => { form.footer_color = new_color; }">
                                </colour-picker>

                                <div class="custom-fields mt-5">
                                    <label>Custom Invite Fields</label>

                                    <editable-custom-field-list
                                        @changed="fields => { form.custom_invite_fields = fields; }">
                                    </editable-custom-field-list>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form-group>

                    <b-button class="mt-3" type="submit" variant="primary">
                        Submit
                    </b-button>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    //import ImagePicker from '@/components/ImagePicker.vue';
    import SimpleImagePicker from '@/components/SimpleImagePicker.vue';
    import ColourPicker from '@/components/ColourPicker.vue';
    import clientRepository from "@/repository/clients";
    import userRepository from "@/repository/users";
    import EditableCustomFieldList from "@/components/EditableCustomFieldList.vue";

    export default {
        components: {
            //ImagePicker,
            SimpleImagePicker,
            ColourPicker,
            EditableCustomFieldList
        },
        
        data() {
            return {
                form: {
                    name: "",
                    user_id:"",
                    password: "",
                    password_confirm: "",
                    logo: "",
                    logo_base64: "",
                    header_color: "#ffffff",
                    footer_color: "#ffffff",
                    custom_invite_fields:[]
                },
                users:[],
                errors: {},
                loaded:false,
            }
        },

        methods: {
            onSubmit() {
                clientRepository.store(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Client Created',
                            text: 'New client successfully created.'
                        });

                        this.clear();
                    }).catch(error=>{
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },

            clear() {
                for (let field in this.form) {
                    this.form[field] = "";
                }

                // hack to ensure form.logo is changed to a new falsy value so that
                // SimpleImagePicker's src prop watcher will detect a change
                this.form.logo = (this.form.logo == "") ? null : "";
            }
        },
        computed:{
          user_options(){
              return this.users.map((user)=>{
                  return {
                      value: user.id,
                      text: user.name
                  }
              })
          }
        },
        mounted(){
            userRepository.getAll()
                .then(response => {
                    this.users= response.data;
                    this.loaded = true;
                });
        }
    }
</script>

<style scoped lang="scss">
    
</style>